import { createFileRoute } from "@tanstack/react-router"

import { DesktopPipeline } from "@/crm/components/pipeline/desktop/board"
import { MobilePipeline } from "@/crm/components/pipeline/mobile/board"
import { Adaptive } from "@/crm/lib/viewport"

export const Route = createFileRoute("/_crm/pipeline")({
  component: PipelineRoute,
})

function PipelineRoute() {
  return <Adaptive desktop={<DesktopPipeline />} mobile={<MobilePipeline />} />
}
